// extracted by mini-css-extract-plugin
export default {"container":"V0AHB_mJJCP2X9mQeVuRD","row":"_2nzdCJLBVhfcvApijawt5G","col":"_lDxN4rp4vQ5heSLwVbc5","icon":"_2SllNu7rQ1s0APBHYQKRhK","links":"FiKB8Dp_3ly5qVBr6nDAZ"};